import styled, { color, device, themeGet } from '@styled'

export const ImgWrapper = styled.section`
  display: inline-block;
  img {
    width: auto;
    max-width: 100px;
    max-height: 25px;
  }
  margin-inline-end: 40px;
  margin-block-end: 10px;
  ${device.small} {
    img {
      max-width: 120px;
      max-height: 30px;
    }
  }
  ${device.medium} {
    img {
      max-width: 160px;
      max-height: 40px;
    }
  }
  ${device.large} {
    img {
      max-width: 190px;
      max-height: 50px;
    }
  }
`

export const SectionWrapper = styled.section`
  padding-block-start: 20px;
  padding-block-end: 30px;
  ${color}
`

export const StyledText = styled.div`
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
  b {
    font-weight: 700;
  }
  ul {
    list-style: disc;
    margin-left: 20px;
  }
`

export const InfoCircle = styled.a`
  @keyframes myfirst {
    0% {
      opacity: 0;
      margin-right: 0px;
    }
    100% {
      opacity: 1;
      margin-right: 10%;
    }
  }
  display: block;
  animation: myfirst 3s;
  position: absolute;
  width: 106px;
  height: 106px;
  font-size: 11px;
  border-radius: 50%;
  background: ${themeGet('colors.secondary')};
  right: 0;
  top: 0;
  cursor: ${(props) => (props.href ? 'pointer' : 'default')};
  margin-right: 10%;
  transform: translateY(-50%);
  :hover {
    background: ${(props) =>
      props.href ? 'rgba(192,115,79)' : themeGet('colors.secondary')};
  }
  ${device.small} {
    font-size: 13px;
    width: 118px;
    height: 118px;
  }
  ${device.medium} {
    font-size: 16px;
    width: 150px;
    height: 150px;
  }
  ${device.large} {
    font-size: 20px;
    width: 200px;
    height: 200px;
  }
`

export const InfoCircleText = styled.div`
  text-align: center;
  color: white;
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
